import { render, staticRenderFns } from "./ViewParentFeedback.vue?vue&type=template&id=fe3ffff4&scoped=true"
import script from "./ViewParentFeedback.vue?vue&type=script&lang=js"
export * from "./ViewParentFeedback.vue?vue&type=script&lang=js"
import style0 from "./ViewParentFeedback.vue?vue&type=style&index=0&id=fe3ffff4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3ffff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3ffff4')) {
      api.createRecord('fe3ffff4', component.options)
    } else {
      api.reload('fe3ffff4', component.options)
    }
    module.hot.accept("./ViewParentFeedback.vue?vue&type=template&id=fe3ffff4&scoped=true", function () {
      api.rerender('fe3ffff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/ViewParentFeedback.vue"
export default component.exports